export default "__VITE_ASSET__DB9BkjL2__"